import m from "../../geodata/es2015/faroeIslandsHigh";
window.am4geodata_faroeIslandsHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/faroeIslandsHigh.js
// module id = null
// module chunks = 